import http from '@services/http';
import { Profiles } from './interfaces';

export const updateSummary = (data: Profiles.Bio.UpdateSummary.Request): Promise<Profiles.Bio.UpdateSummary.Response> => {
  return http.put(`/profiles/${data.userId}/bio/summary`, data);
};